const options = {
  year: "numeric",
  month: "short",
  day: "numeric",
  hour: "numeric",
  minute: "numeric",
  second: "numeric",
} as Intl.DateTimeFormatOptions;

const getCurrentDate = () => new Date().toLocaleDateString("en-US", options);

export default getCurrentDate;
